/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect } from 'react'
import clsx from 'clsx'

interface Props extends React.HTMLAttributes<'div'> {
  bodyElemenyById?: string
}

export default function EndlessContainer({ bodyElemenyById, ...props }: Props) {
  const [containerWidth, setContainerWidth] = useState<number | null>(null)
  const containerRef = useRef<HTMLDivElement>(null)

  const handleResize = () => {
    if (!containerRef.current) {
      return
    }

    const width = containerRef.current.getBoundingClientRect().width
    const clientWidth = bodyElemenyById ? document.getElementById(bodyElemenyById)?.clientWidth || 0 : document.body.clientWidth
    const spaceLeft = (clientWidth - width) / 2

    setContainerWidth(Math.round(width + spaceLeft))
  }

  useEffect(() => {
    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', () => handleResize)
    }
  }, [containerRef])

  return (
    <>
      <div className={clsx('container', props.className)} ref={containerRef} />
      <div
        className="ml-auto pl-4"
        style={{
          width: containerWidth || '100%'
        }}
      >
        {props.children}
      </div>
    </>
  )
}
